export default function ClinicSection() {
  return (
    <section id="clinica" data-cascade className="relative w-full bg-offwhite paper-texture overflow-hidden">
      <div className="flex flex-col lg:flex-row min-h-[600px] lg:min-h-[700px]">
        {/* Full-height editorial image */}
        <div data-cascade-image className="w-full lg:w-[55%] h-[350px] lg:h-auto relative overflow-hidden">
          <img
            src="https://storage.helloreaddy.io/project_files/7ae9a526-920c-4103-99ac-b845e125a623/d6738dd7-541e-490c-8753-330cbc7fcd73_compressed_Imagem-1-gerada-13.webp"
            alt="Clínica Dra. Nathália Posso - Fortaleza"
            title="Clínica Dra. Nathália Posso | Consultório em Fortaleza"
            className="w-full h-full object-cover"
          />
          {/* Subtle gradient overlay */}
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-offwhite/50" />
        </div>

        {/* Text side */}
        <div className="w-full lg:w-[45%] flex flex-col justify-center px-6 md:px-16 py-14 lg:py-20 bg-offwhite/80 backdrop-blur-sm">
          <p data-cascade-label className="font-body text-[10px] md:text-[11px] text-secondary-500 tracking-[0.4em] uppercase mb-3">
            Nossa Clínica
          </p>
          <div data-cascade-line className="w-12 h-[1px] bg-gold-matte/40 mb-6" />
          <h2 data-cascade-title className="font-heading text-2xl md:text-3xl lg:text-4xl text-graphite font-light leading-[1.2] mb-6">
            Um espaço pensado para o seu{' '}
            <span className="italic">conforto</span> e{' '}
            <span className="italic">bem-estar</span>.
          </h2>
          <p data-cascade-text className="font-body text-sm text-graphite/55 leading-relaxed font-light mb-8 max-w-md">
            Nossa clínica foi projetada para oferecer uma experiência de atendimento
            que vai além do consultório tradicional. Cada detalhe do ambiente foi
            pensado para que você se sinta acolhida e tranquila.
          </p>

          <div className="flex flex-col gap-4 mb-8">
            {[
              { icon: 'ri-map-pin-line', label: 'Endereço', text: 'Duets Office Towers · Torre Sul - Rua Dr. Gilberto Studart, 55 · Sl 610 · Cocó · Fortaleza - CE, 60192-105' },
              { icon: 'ri-phone-line', label: 'Telefone', text: '(85) 98429.3412' },
              { icon: 'ri-time-line', label: 'Horários', text: 'Segunda a Sexta · 8h às 18h' },
            ].map((item) => (
              <div key={item.label} className="flex items-start gap-3 group cursor-pointer hover:translate-x-1 transition-transform duration-300">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className={`${item.icon} text-gold-matte/50 text-sm group-hover:text-gold-matte/70 transition-colors duration-300`} />
                </div>
                <div>
                  <p className="font-body text-xs text-graphite/75 font-medium">{item.label}</p>
                  <p className="font-body text-xs text-graphite/55 font-light">
                    {item.text}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div data-cascade-buttons className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://www.google.com/maps/place/Femme+Vie/@-3.7414551,-38.4872636,17z/data=!3m1!4b1!4m6!3m5!1s0x7c748ee49695555:0x5ae6d9fed6392be3!8m2!3d-3.7414551!4d-38.4872636!16s%2Fg%2F11fzk6bkdp?entry=ttu&g_ep=EgoyMDI2MDgwNS4xIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
              className="font-body text-xs font-medium text-graphite/65 hover:text-graphite hover:scale-[1.02] border border-secondary-300/40 hover:border-secondary-400/60 px-8 py-3 tracking-[0.12em] uppercase transition-all duration-300 text-center whitespace-nowrap"
            >
              Ver no Mapa
            </a>
            <a
              href="https://api.whatsapp.com/send/?phone=5585984293412&text=Ol%C3%A1%21+Gostaria+de+informa%C3%A7%C3%B5es+sobre+procedimentos+e+consultas+com+a+Dra+Nathalia&type=phone_number&app_absent=0"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-shimmer font-body text-xs font-semibold text-white bg-graphite hover:bg-graphite/85 hover:scale-[1.02] px-8 py-3 tracking-[0.12em] uppercase transition-all duration-500 text-center whitespace-nowrap"
            >
              Agendar Consulta
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}